const DownloadLinkCell = (value) => {
    const Downloadable = <a href={value}><img className="download-report-icon" src="/images/download_item.svg" alt="download-icon" /></a>
    return <div className="reports-download-cta">{Downloadable}</div>;
};

export default DownloadLinkCell